import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { trackPageView } from '../services/google-analytics';
import { COLOR_TEXT, COLOR_WHITE } from '../styles/colors';
import MEDIA from '../styles/media';
import clsx from 'clsx';

interface FormPageTemplateProps {
  children: any;
  checked?: boolean;
}

const useStyles = makeStyles(theme => ({
  formPageTemplate: {
    width: '100vw',
    height: '100vh',
    minHeight: '600px',
    display: 'flex',
  },

  leftHalf: {
    width: '50%',
    height: '100%',
    position: 'relative',
    backgroundImage: 'url(/images/login-background-left.jpg)',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    transition: 'background-position 0.3s ease, opacity 0.3s ease',
  },
  leftHalfSsa: {
    width: '50%',
    height: '100%',
    position: 'relative',
    backgroundImage: 'url(/svgs/ssa_bg-Icon.jpg)',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    transition: 'background-position 0.3s ease, opacity 0.3s ease',
  },
  leftHalfImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  logoWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(4),
  },
  logo: {
    transition: 'background-position 0.3s ease, opacity 0.3s ease',
    width: '300px',
  },

  ssaLogo: {
    transition: 'background-position 0.3s ease, opacity 0.3s ease',
    maxWidth: '100%',
  },

  title: {
    ...theme.typography.h1,
    padding: 0,
    margin: theme.spacing(3, 0, 0),
    textAlign: 'center',
    color: COLOR_WHITE,
    transition: 'background-position 0.3s ease, opacity 0.3s ease',
  },

  ssaTitle: {
    ...theme.typography.h1,
    padding: 0,
    margin: theme.spacing(1.25, 0, 0),
    textAlign: 'center',
    color: COLOR_WHITE,
    fontSize: theme.typography.pxToRem(26),
    fontWeight: 700,
    transition: 'background-position 0.3s ease, opacity 0.3s ease',
  },

  rightHalf: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50%',
    height: '100%',
    padding: theme.spacing(4),
    backgroundColor: COLOR_WHITE,
    backgroundImage: 'url(/images/login-background-right.jpg)',
    backgroundPosition: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
  },

  [MEDIA.TABLET]: {
    leftHalf: {
      width: '40%',
    },

    rightHalf: {
      width: '60%',
    },
  },

  [MEDIA.MOBILE]: {
    formPageTemplate: {
      flexWrap: 'wrap',
      flexDirection: 'column',
      height: 'auto',
      minHeight: '100vh',
      backgroundColor: COLOR_WHITE,
    },

    leftHalf: {
      width: '100%',
      height: 'auto',
      background: 'none',
    },

    leftHalfSsa: {
      width: '100%',
      height: 'auto',
      background: 'none',
    },
    logo: {
      display: 'none'
    },

    ssaLogo: {
      display: 'none',
    },

    ssaTitle: {
      color: COLOR_TEXT,
    },

    logoWrapper: {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      transform: 'none',
    },

    title: {
      fontSize: theme.typography.pxToRem(20),
      color: COLOR_TEXT,
    },

    rightHalf: {
      width: '100%',
      height: 'auto',
      flex: '1 1 auto',
      justifyContent: 'flex-start',
    },
  },
}), { name: FormPageTemplate.name });

export default function FormPageTemplate (props: FormPageTemplateProps) {
  const { children, checked } = props;
  const classes = useStyles();

  useEffect(() => {
    trackPageView();
  }, []);

  return (
    <main className={classes.formPageTemplate}>
      <div className={clsx(checked ? classes.leftHalfSsa : classes.leftHalf)}>
        <div className={classes.logoWrapper}>
          <img
            className={checked ? classes.ssaLogo : classes.logo}
            src={checked 
              ? '/svgs/sportsource-analytics-logo.svg' 
              : '/images/tracking-football-logo-text.svg'
            }
            alt='Tracking Football®'
          />

          <h2 className={checked ? classes.ssaTitle : classes.title}>
            {checked ? <>A Tracking Football® Company</> : <> Our Data. <strong>Your Advantage.</strong>®</>}
          </h2>
        </div>
      </div>

      <div className={classes.rightHalf}>
        {children}
      </div>
    </main>
  );
}
